
import { Component, Prop, Vue } from 'vue-facing-decorator'
import AuditReturn from '../dialog/audit-return.vue'

@Component({})
export default class extends Vue {
  /** 申请单，取自 orderInfo.applicationList */
  @Prop()
  modelValue: any

  /**
   * initiatorId 只有后台主动发起的退款才有（create-returns 会写），
   * 买家自己申请的没有，所以拿它区分来源。
   * 主动退款那条路 approveStatus 直接落 1，下面自然不会给审批按钮
   */
  get typeText() {
    if (this.modelValue.initiatorId) {
      return "主动退款";
    }
    /** type 1 仅退款 2 退款退货 */
    return this.modelValue.type == 2 ? "买家申请退货退款" : "买家申请退款";
  }

  /** 审批状态 0 待审批 1 通过 2 拒绝 3 撤销申请 */
  get statusText() {
    switch (this.modelValue.approveStatus) {
      case 0:
        return "待审批";
      case 1:
        return "已通过";
      case 2:
        return "已拒绝";
      case 3:
        return "已撤销";
    }
    return "";
  }

  get statusClass() {
    switch (this.modelValue.approveStatus) {
      case 0:
        return "status-pending";
      case 1:
        return "status-pass";
      case 2:
        return "status-reject";
    }
    return "";
  }

  /** 只有待审批的给操作，审过的再点后端也不会过 */
  get canAudit() {
    return this.modelValue.approveStatus == 0;
  }

  async audit(status) {
    try {
      await this.$dialog({
        title: status == 1 ? "同意退款" : "拒绝退款",
        props: {
          width: "440px",
        },
        content: () => {
          return <AuditReturn data={this.modelValue} status={status}></AuditReturn>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("审批完成");
    this.$emit("refresh");
  }
}
